__turbopack_context__.v({
  "tab": "Tabs-module-scss-module__8aWbhG__tab",
  "tab-btn": "Tabs-module-scss-module__8aWbhG__tab-btn",
  "tabs": "Tabs-module-scss-module__8aWbhG__tabs",
  "tabs-list": "Tabs-module-scss-module__8aWbhG__tabs-list",
  "underline": "Tabs-module-scss-module__8aWbhG__underline",
});
